import { Navigate, useLocation } from 'react-router-dom'
import { useAppSelector } from '@store/hooks'
import { Box, CircularProgress } from '@mui/material'
import { isAdminPanelRole } from '@utils/adminPermissions'

interface AdminRouteProps {
  children: React.ReactNode
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAppSelector((state) => state.auth)
  const location = useLocation()

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  if (!isAdminPanelRole(user?.role)) {
    return <Navigate to="/app" replace />
  }

  return <>{children}</>
}

export default AdminRoute
